// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteIcon__wrapper--2aS","actuator":"FavoriteIcon__actuator--2_u","icon":"FavoriteIcon__icon--5Vy","featured":"FavoriteIcon__featured--3Yo","on":"FavoriteIcon__on--2YX"};